import React, { useState } from "react";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import TextField from "@mui/material/TextField";
import IndividualDeliverable from "./individualDeliverable";
import InputAdornment from '@mui/material/InputAdornment';
import { useFormik } from "formik";
import * as Yup from "yup";
import { Input, Spinner } from "reactstrap";
import dayjs from "dayjs";
import { ChangeRequestModule } from "../../../constants/Module";
import { Action } from "../../../constants/Common";
import { withTranslation } from "react-i18next";

const AddDeliverableModule = (props) => {
    const newDeliverableObject = {
        name: "",
        cost: "",
        weight: "",
        description: "",
        expectedOutput: "",
        startDate: '',
        endDate: '',
      }

    const [isLoading, setIsLoading] = useState(false)

    const deliverableCreateValidation = Yup.object().shape({
        name: Yup.string()
          .strict(true)
          .trim(props.t('Must not include leading and trailing spaces'))
          .min(2, props.t("Too Short!"))
          .max(250, props.t("Too Long!"))
          .matches(/^(?=.*[a-zA-Z0-9])[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/? ]*$/, props.t("Name should be in proper type"))
          .required(props.t("Please enter name")),
          description: Yup.string()
            .max(2000, props.t("Description can not be greater than 2000 characters"))
            .strict(true)
            .trim(props.t('Must not include leading and trailing spaces'))
            .required(props.t("Please Enter description")),
        expectedOutput: Yup.string()
            .strict(true)
            .trim(props.t('Must not include leading and trailing spaces'))
            .max(250, props.t("Too Long!"))
            .required(props.t("Please Enter expected output")),
        cost: Yup.number()
        .moreThan(0, props.t("Cost cannot be 0 or negative"))
        .required(props.t("Please Enter cost")) 
        .max(props.updatedProject?.projectCost?.new ?? props.project.projectCost, `${props.t('Cost of Deliverable can not exceed the project cost')} ${props.updatedProject?.projectCost?.new ?? props.project.projectCost}`)
        .test(props.t('two decimal places'), props.t('Numbers can only have two decimal places'), (value) => {
            return value === null || (value && /^\d+(\.\d{0,2})?$/.test(String(value)));
        }),        
        weight: Yup.number()
            .min(0, props.t('Too short!'))
            .integer()
            .required(props.t("Please Enter weight"))
            .max(100, props.t('Weight cannot exceed more than 100')),          
        startDate: Yup.date()
        .typeError(props.t("Given date is invalid type"))
        .required(props.t("Please Enter start date"))
        .min(props.updatedProject?.schedule?.startDate?.new ?? dayjs(props.project?.startDate).format('MM/DD/YYYY'), props.t('Deliverable start date cannot be less than project start date') + ' ' + dayjs(props.updatedProject?.schedule?.startDate?.new ?? props.project?.startDate).format('MM/DD/YYYY'))
        .max(props.updatedProject?.schedule?.endDate?.new ?? dayjs(props.project?.endDate).format('MM/DD/YYYY'), `${props.t('Deliverable start date cannot be greater than project end date')} ' ' ${dayjs(props.updatedProject?.schedule?.endDate?.new ?? props.project.endDate).format('MM/DD/YYYY')}`)
        .when('endDate', {
            is: (endDate) => { return !!endDate },
            then: (schema) => schema.max(Yup.ref('endDate'), props.t("Start date cannot be after End date"))
        }),
        endDate: Yup.date()
        .typeError(props.t("Given date is invalid type"))
        .required(props.t("Please Enter end date"))
        .max(props.updatedProject?.schedule?.endDate?.new ?? dayjs(props.project?.endDate).format('MM/DD/YYYY'), `${props.t('Deliverable end date cannot be greater than project end date')} ' ' ${dayjs(props.updatedProject?.schedule?.endDate?.new ?? props.project.endDate,).format('MM/DD/YYYY')}`)
        .when('startDate', {
            is: (startDate) => !!startDate,
            then: (schema) => schema.min(Yup.ref('startDate'), props.t("End date cannot be before Start date")),
        }),
        // projectId: Yup.number().required(),
      },['startDate', 'endDate']);

    const createDeliverableFormik = useFormik({
    initialValues: {
        ...newDeliverableObject,
    },
    validationSchema: deliverableCreateValidation,
    validateOnMount: true,
    onSubmit: (values) => {
        try {
            setIsLoading(true)
            props.validate({
                module: ChangeRequestModule.DELIVERABLE,
                event: Action.CREATE,
                }, values, () => {
                createDeliverableFormik.resetForm({
                    ...newDeliverableObject
                    })
                    setIsLoading(false)
                },
                () => {
                setIsLoading(false)
                })
        } catch (e) {
            // not handle any changes
        }
    },
        });

    const handleKeyDownCost = (event) => {

        if (event.keyCode === 8 || event.keyCode === 13) {
            return;
        }
        const value = event.target.value;
        const regex = /^\d*\.?\d{0,2}$/;
        
        if (!regex.test(value + event.key)) {
            event.preventDefault(); 
        }
    }

    const handleKeyDownWeight = (event) => {

        if (event.keyCode === 8 || event.keyCode === 13) {
          return;
        }
       
        const regex = /^[0-9]+$/;
    
        if (!regex.test(event.key)) {
          event.preventDefault(); 
        }
    }

    return(
    <div className="editDeliverable_height" style={{height: 'auto', maxHeight: '900px'}}>
        <div className="dashed_border position-relative mt-3 mb-5" style={{paddingBottom: '10px'}}>
            <div className="row">
                <div className="col-md-12 mt-2">
                    <TextField
                        fullWidth
                        id="outlined-multiline-static"
                        label={props.t("Name")}
                        name="name"
                        disabled={isLoading}
                        value={createDeliverableFormik.values.name}
                        onChange={createDeliverableFormik.handleChange}
                        onBlur={createDeliverableFormik.handleBlur}
                        required
                    />
                    {createDeliverableFormik.touched.name &&
                createDeliverableFormik.errors.name && (
                    <span className="text-danger d-block">
                    {createDeliverableFormik.errors.name}
                    </span>
                )}
                </div>
            </div>
            <div className="row">
            <div className="col-sm-12 mt-2">
            <TextField
                  fullWidth
                  className="form-control"
                  id="deliverable-title-input"
                  label= {props.t("Description")}
                  name="description"
                  value={createDeliverableFormik.values.description}
                  disabled={isLoading}
                  onChange={createDeliverableFormik.handleChange}
                  onBlur={createDeliverableFormik.handleBlur}
                  multiline
                  required
                  rows={2}
                />
                {createDeliverableFormik.touched.description && createDeliverableFormik.errors.description && (
                <span className="text-danger">{createDeliverableFormik.errors.description}</span>
              )}
              </div>
              </div>
              <div className="row">
              <div className="col-sm-12 mt-2">
              <TextField
                  fullWidth
                  className="form-control"
                  id="deliverable-title-input"
                  label= {props.t("Expected Output")}
                  name="expectedOutput"
                  value={createDeliverableFormik.values.expectedOutput}
                  disabled={isLoading}
                  onChange={createDeliverableFormik.handleChange}
                  onBlur={createDeliverableFormik.handleBlur}
                  multiline
                  required
                  rows={3}
                />
                {createDeliverableFormik.touched.expectedOutput && createDeliverableFormik.errors.expectedOutput && (
                <span className="text-danger">{createDeliverableFormik.errors.expectedOutput}</span>
              )}
              </div>
              </div>
            <div className="row">
                <div className="col-md-6 mt-2 pe-0 plCurrency currency_small_font">
                    {/* <TextField
                        fullWidth
                        id="outlined-multiline-static"
                        label={props.t("Cost")}
                        name="cost"
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={handleKeyDownCost}
                        disabled={isLoading}
                        InputProps={{
                            startAdornment: <InputAdornment position="start">SAR</InputAdornment>,
                        }}
                        value={createDeliverableFormik.values.cost}
                        onChange={createDeliverableFormik.handleChange}
                        onBlur={createDeliverableFormik.handleBlur}
                        required
                    /> */}
                    <TextField
                        minimumValue="0"
                        id="deliverable-cost"
                        variant="outlined"
                        // label='Deliverable Cost'
                        decimalPlaces={2}
                        value={createDeliverableFormik.values.cost}
                        // size="small"
                        currencySymbol={props.t("SAR")}
                        fullWidth
                        placeholder={props.t("Deliverable Cost")}
                        required

                        disabled={isLoading}
                        onChange={(e, newValue) => {
                            createDeliverableFormik.setFieldValue('cost', newValue === 0 ? '' : newValue, true)
                        }}
                        onBlur={() => {
                            createDeliverableFormik.setFieldTouched('cost', true, true)
                        }}
                    />
                    {createDeliverableFormik.touched.cost &&
                createDeliverableFormik.errors.cost && (
                    <span className="text-danger d-block">
                    {createDeliverableFormik.errors.cost}
                    </span>
                )}
                </div>
                <div className="col-md-6 mt-2">
                    <TextField
                        fullWidth
                        id="outlined-multiline-static"
                        label={props.t("Weight")}
                        type="number"
                        name="weight"
                        onWheel={(e) => e.target.blur()}
                        disabled={isLoading}
                        onKeyDown={handleKeyDownWeight}
                        value={createDeliverableFormik.values.weight}
                        onChange={createDeliverableFormik.handleChange}
                        onBlur={createDeliverableFormik.handleBlur}
                        required
                    />
                    {createDeliverableFormik.touched.weight &&
                createDeliverableFormik.errors.weight && (
                    <span className="text-danger d-block">
                    {createDeliverableFormik.errors.weight}
                    </span>
                )}
                </div>
            </div>
            <div className="row">
                <div className=" col-md-6 changeRequest_datePicker mt-2 pe-0">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DatePicker']}>
                            <DatePicker
                                label={props.t("Start Date") + ' *'}
                                format="MM/DD/YYYY"
                                name="startDate"
                                disabled={isLoading}
                                value={
                                    createDeliverableFormik?.values?.startDate?.toString().trim()
                                    ? createDeliverableFormik.values.startDate
                                    : null
                                }
                                on
                                slotProps={{
                                field: { clearable: true, onBlur: (_) => { 
                                    if (!createDeliverableFormik.touched?.startDate) {
                                    createDeliverableFormik.setFieldTouched("startDate", true, false);
                                } 
                                }},
                                onClear: () => {
                                    createDeliverableFormik.setFieldValue("startDate", '');
                                },
                                }}
                                onChange={(e) => {
                                createDeliverableFormik.setFieldValue(
                                    "startDate",
                                    e ? dayjs(e).format("YYYY-MM-DD") : ''
                                );
                                if (!createDeliverableFormik.touched?.startDate) {
                                    createDeliverableFormik.setFieldTouched("startDate", true, false);
                                }
                                }}
                                required
                             />
                        </DemoContainer>
                    </LocalizationProvider>
                    {createDeliverableFormik.touched.startDate &&
                createDeliverableFormik.errors.startDate && (
                    <span className="text-danger d-block">
                    {createDeliverableFormik.errors.startDate}
                    </span>
                )}
                </div>
                <div className="col-md-6 changeRequest_datePicker mt-2">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DatePicker']}>
                            <DatePicker
                                label={props.t("End Date") + ' *'}
                                format="MM/DD/YYYY"
                                name="endDate"
                                disabled={isLoading}
                                value={
                                createDeliverableFormik?.values?.endDate?.toString().trim()
                                    ? createDeliverableFormik.values.endDate
                                    : null
                                }
                                slotProps={{
                                field: { clearable: true, onBlur: (_) => {
                                    if (!createDeliverableFormik.touched?.endDate) {
                                    createDeliverableFormik.setFieldTouched("endDate", true, false);
                                }
                                }},
                                onClear: () => {
                                    createDeliverableFormik.setFieldValue("endDate", '');
                                },
                                }}
                                onChange={(e) => {
                                createDeliverableFormik.setFieldValue(
                                    "endDate",
                                    e ? dayjs(e).format("YYYY-MM-DD") : ''
                                );
                                if (!createDeliverableFormik.touched?.endDate) {
                                    createDeliverableFormik.setFieldTouched("endDate", true, false);
                                }
                                }}
                                required
                            />
                        </DemoContainer>
                    </LocalizationProvider>
                    {createDeliverableFormik.touched.endDate &&
                createDeliverableFormik.errors.endDate && (
                    <span className="text-danger d-block">
                    {createDeliverableFormik.errors.endDate}
                    </span>
                )}
                </div>
            </div>
            <div className="d-flex justify-content-center align-items-center mt-4">
                <button className={`add_anotherButton d-flex align-items-center ${isLoading || !createDeliverableFormik.isValid ? 'bg-secondary' : ''}`} type="button" onClick={createDeliverableFormik.handleSubmit} disabled={isLoading || !createDeliverableFormik.isValid}>
                    {isLoading ? (<Spinner className="ml-1" type="border" color="light" size="sm" />) : (<i className="ri-add-line ml-1" />)}
                    <span className="pe-2 ps-1">{props.t('Add')}</span>
                </button>
            </div>
        </div>
        {
            props?.deliverableList && props?.deliverableList?.map((dL, index) => {
                return (<IndividualDeliverable key={index} action={Action.CREATE} eachDeliverable={dL}  eachDeliverableIndex={index} removeItemFromPayload={props?.removeItemFromPayload} />)
            })
        }
    </div>
    )
}

export default withTranslation() (AddDeliverableModule);